import { render, staticRenderFns } from "./ClassPerformanceBatch.vue?vue&type=template&id=7c8a82d2&scoped=true&"
import script from "./ClassPerformanceBatch.vue?vue&type=script&lang=js&"
export * from "./ClassPerformanceBatch.vue?vue&type=script&lang=js&"
import style0 from "./ClassPerformanceBatch.vue?vue&type=style&index=0&id=7c8a82d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8a82d2",
  null
  
)

export default component.exports